module.exports = __webpack_public_path__ + "static/preview-sm-2-730652d59a0a5d5325d0ad63bb094992.jpg";